import React, { useState, useEffect, useRef, useCallback, Fragment } from "react";
import { useGameContext } from '../GameContext';
import { SUBTITLE_RESTRICTION, TIMERS_GAME } from '../../utils/constants';
import icoQOff from '../../assets/ico-q-off.svg';
import icoQOn from '../../assets/ico-q-on.svg';
import txtIndicator from '../../assets/text-indicator.svg';

import { ANIMATIONS } from "../../utils/constants";
import "./Qualification.css";

import { getFileType } from "../../utils/mediaUtils";
import ControlledMediaPlayer from "../Media/MediaPlater/ControlledMediaPlayer";

import popSound from "../../assets/audios/pop.mp3";
import SyncedSubtitle from "../Subtitles/SyncedSubtitle";
import SubtitleRenderer from "../Subtitles/SubtitleRenderer";


const QualificationComponent = ({ playAnimation }) => {
    const [samTalking, setSamTalking] = useState(true);
    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);

    const { user, game, socket, room } = useGameContext();
    const player = game.players.find(player => player.id === user);
    const currentAnswer = game.current_answer_qualification;

    const videoRef = useRef(null);
    const audioRef = useRef(null);
    const prevAnswerRef = useRef();

    const handleConfirm = (isAnimating = 1) => {
        playSound();
        socket.emit("response_qualification", { rating, questionId: game.current_question.id, gameKey: game.id, user });
        setIsConfirmed(true);

        if (isAnimating) {
            setIsAnimating(false);
            playAnimation(ANIMATIONS.talking, 4);
            setTimeout(() => {
                setSamTalking(false);
            }, 4000);
        }

    };

    const playSound = () => {
        const sound = new Audio(popSound);
        sound.play();
    };

    const isOwnAnswer = currentAnswer?.player_id === player?.id;

    // Detectar cambio de pregunta y ejecutar animación
    useEffect(() => {
        if (prevAnswerRef.current?.player_id !== currentAnswer?.player_id) {
            setIsConfirmed(false);
            setRating(0);

            setIsAnimating(true);

        }
        prevAnswerRef.current = currentAnswer;
    }, [currentAnswer]);

    // Efecto para calificar automáticamente con 0 si la respuesta es "no_answer" y no es del usuario
    useEffect(() => {
        if (currentAnswer?.answer === "no_answer" && !isOwnAnswer && !isConfirmed) {
            handleConfirm(0);
        }
    }, [currentAnswer, isOwnAnswer, isConfirmed]);

    const [isCCActive, setIsCCActive] = useState(false);
    const [subtitle, setSubtitle] = useState('');
    const handleSubtitleChange = useCallback((text) => {
        if(isCCActive) {
            setSubtitle(text);
        }
    }, [isCCActive]);
    useEffect(() => {
        playAnimation(ANIMATIONS.talking, 4);
        setTimeout(() => {
            setSamTalking(false);
        }, 4000);
        if(game.gameName.toLowerCase() === SUBTITLE_RESTRICTION.toLowerCase()) {
            setIsCCActive(localStorage.getItem("subtitles") === "true");
        }
    }, []);

    const Answer = useCallback((subtitle, isCCActive) => {
        if (currentAnswer.answer === "no_answer") {
            return (<div className="whitebox-purple-border">
                <p>¡Oh! Un viajero no respondió a tiempo</p>
            </div>);
        }

        if (game.current_question.tipoRespuesta === "foto") {
            return (
                <div className="flex items-center justify-center">
                    <img src={currentAnswer.answer} alt="Respuesta del usuario" className="image-box" />
                </div>
            )
        }

        if (game.current_question.tipoRespuesta === "video") {
            return (
                <div className="flex items-center justify-center">
                    <SyncedSubtitle ref={videoRef} onCloseCaptionChange={handleSubtitleChange} />
                    <SubtitleRenderer text={subtitle} isActive={isCCActive} isAbsolute />
                    <video className="video-box" ref={videoRef} autoPlay src={currentAnswer.answer} controls />
                </div>
            )
        }

        if (game.current_question.tipoRespuesta === "audio") {
            return (
                <div className="flex flex-col justify-center gap-1">
                    <SyncedSubtitle ref={audioRef} onCloseCaptionChange={handleSubtitleChange} />
                    <SubtitleRenderer text={subtitle} isActive={isCCActive} />
                    <div className="flex items-center justify-center">
                        <ControlledMediaPlayer ref={audioRef} mediaUrl={currentAnswer.answer} />
                    </div>
                </div>
            );
        }

        if (game.current_question.tipoRespuesta === "texto") {
            return <div className="whitebox-purple-border">
                <p className="answer-text">{currentAnswer.answer}</p>
            </div>;
        }
    }, [currentAnswer.answer, game.current_question.tipoRespuesta, handleSubtitleChange])

    return (
        <div className="queContainer">
            {game.timeToStart <= 15 && <div className="timerCont">{game.timeToStart}</div>}
            <div className={`blockContent ${isAnimating ? "show" : ""}`}>
                <div className={`TextboxContainer`}>
                    <div className="Textbox">
                        {samTalking && <div>
                            <label>Hora de calificar las respuestas de los demás viajeros</label>
                            <img className="txtIndicator" src={txtIndicator} alt="txt indicator" />
                        </div>}

                        {!samTalking && (
                            <div>
                                <label>{game.current_question.challenge}</label>
                                {/* Verificar si hay al menos una URL */}
                                {game.current_question.url && game.current_question.url.length > 0 && (
                                    <div className="media-gallery">
                                        {(() => {
                                            const mediaUrl = game.current_question.url[0];
                                            const fileType = getFileType(mediaUrl);

                                            if (fileType === "image") {
                                                return <img src={mediaUrl} alt="Imagen de la pregunta" className="question-image" />;
                                            } else if (fileType === "video") {
                                                return (
                                                    <div className="flex items-center justify-center">
                                                        <SyncedSubtitle ref={videoRef} onCloseCaptionChange={handleSubtitleChange} />
                                                        <SubtitleRenderer text={subtitle} isActive={isCCActive} isAbsolute />
                                                        <video src={mediaUrl} controls className="question-video" />
                                                    </div>
                                                );
                                            } else {
                                                return <p className="unsupported-media">Tipo de archivo no soportado</p>;
                                            }
                                        })()}
                                    </div>
                                )}
                            </div>
                        )}


                        {isOwnAnswer && !samTalking && <div className="textNotQualification">
                            <label><b style={{ fontWeight: '700', fontSize: '23px', color: '#0d61cc' }}>Los demás viajeros están calificando tu respuesta</b></label>
                            <img className="txtIndicator" src={txtIndicator} alt="txt indicator" />
                        </div>}
                    </div>
                </div>

                <div className="mediaContainer">
                    {!isOwnAnswer && currentAnswer && <div className="center">
                        {Answer(subtitle, isCCActive)}
                    </div>}

                    {!isOwnAnswer && !currentAnswer &&
                        <div className="whitebox-purple-border">
                            <p>No hay respuestas para calificar</p>
                        </div>}

                    {!isOwnAnswer && currentAnswer && currentAnswer.answer !== "no_answer" &&
                        <div className="center">
                            <div className="rating-stars yellowbox-purple-border">
                                {[...Array(5)].map((_, index) => {
                                    const ratingValue = index + 1;
                                    return (
                                        <label key={index}>
                                            <input type="radio" name="rating" value={ratingValue} onClick={() => setRating(ratingValue)} disabled={isConfirmed} />
                                            <img className="star" src={ratingValue <= (hover || rating) ? icoQOn : icoQOff} alt="logo game" onMouseEnter={() => setHover(ratingValue)} onMouseLeave={() => setHover(0)} />
                                        </label>
                                    );
                                })}
                            </div>

                            <button className="ConfirmButton" onClick={handleConfirm} disabled={rating === 0 || isConfirmed}>
                                <div className="principalBtn">
                                    {isConfirmed ? 'Enviado' : 'Enviar'}
                                </div>
                            </button>
                        </div>}
                </div>
            </div>
            <div className={`slideContent ${!isAnimating ? "show-greeting" : ""}`}>
            <div className={`TextboxContainer`}>
                    <div className="Textbox">
                        <div>
                            <label>Gracias por calificar</label>
                            <img className="txtIndicator" src={txtIndicator} alt="txt indicator" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default QualificationComponent;
